import * as React from "react";
import { useEffect } from "react";
import { nicePrice } from "~/lib/money.ts";

//2024 year-to-date contributions before doess launch, in dollars

function animate(total: number) {
  if (document.querySelector(".ContributionTicker__Box")) {
    //convert from cents to dollars
    total = Math.round(total / 100);
    let strTotal = total.toString().padStart(6, "0");

    for (let i = 0; i < strTotal.length; i++) {
      setTimeout(() => {
        const percent = parseInt(strTotal[i]) * 100 + 100;
        const n = parseInt(strTotal[i]) + 1;
        const style = `transform: translateY(-${percent}%); transition-duration: ${n * 0.5}s`;
        //@ts-expect-error
        document
          .querySelector(`.--box-value-${i}`)
          .setAttribute("style", style);
      }, 250 * i);
    }
  }
}

function makeBoxes(goal: number) {
  const tickerBoxes = [];
  for (let i = 0; i < 6; i++) {
    tickerBoxes.push(
      <div className={`ContributionTicker__Box`} key={`ticker-box-${i}`}>
        <div className={`ContributionTicker__BoxValues --box-value-${i}`}>
          <span className="ContributionTicker__BoxValue"></span>
          <span className="ContributionTicker__BoxValue">0</span>
          <span className="ContributionTicker__BoxValue">1</span>
          <span className="ContributionTicker__BoxValue">2</span>
          <span className="ContributionTicker__BoxValue">3</span>
          <span className="ContributionTicker__BoxValue">4</span>
          <span className="ContributionTicker__BoxValue">5</span>
          <span className="ContributionTicker__BoxValue">6</span>
          <span className="ContributionTicker__BoxValue">7</span>
          <span className="ContributionTicker__BoxValue">8</span>
          <span className="ContributionTicker__BoxValue">9</span>
        </div>
      </div>,
    );
  }
  //insert comma
  tickerBoxes.splice(3, 0, <span key={"key"} className="ContributionTicker__Comma">,</span>);

  return (
    <div className={`ContributionTicker`}>
      <div className="ContributionTicker__Boxes">
        <span className="ContributionTicker__DollarSign">$</span>
        {tickerBoxes}
      </div>
      <div
        className={`ContributionTicker__After`}
      >
        CONTRIBUTED&nbsp;TOWARDS <br className="ContributionTicker__AfterBR" />
        <span className="goal">{nicePrice(goal * 100, 0)}</span>&nbsp;GOAL
      </div>
    </div>
  );
}

export function ContributionMeter({ total, goal }: { total: number; goal: number }) {
  useEffect(() => {
    animate(total);
  }, []);

  return (
    <div>
      {makeBoxes(goal)}
    </div>
  );
}

export default ContributionMeter;
